"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalibrationModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const inputnumber_1 = require("primereact/inputnumber");
const GenericButton_1 = require("../../components/web-view/button/GenericButton");
const react_i18next_1 = require("react-i18next");
const CalibrationModal = ({ saveCalibration, aisle, }) => {
    const [newWeight, setNewWeight] = react_1.default.useState(0);
    const [showValidation, setShowValidation] = react_1.default.useState(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const isValidWeight = newWeight !== null && newWeight > 0;
    const handleCalibration = (e) => {
        setNewWeight(e.value);
        setShowValidation(false);
    };
    const handleSave = () => {
        if (!isValidWeight) {
            setShowValidation(true);
            return;
        }
        saveCalibration(newWeight);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col justify-between gap-4 items-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "p-inputgroup w-5/6", children: [(0, jsx_runtime_1.jsx)(inputnumber_1.InputNumber, { value: newWeight, min: 0, 
                        // La altura vive en el wrapper (border-box) para que coincida
                        // exactamente con la del addon y el input no sobresalga.
                        className: "flex-1 h-12 border-2 border-blue-950 rounded-l-xl overflow-hidden", inputClassName: "w-full h-full border-none pl-4 text-lg", placeholder: "", onChange: handleCalibration }), (0, jsx_runtime_1.jsx)("span", { className: "p-inputgroup-addon bg-blue-950 text-white h-12 w-12 rounded-r-xl flex items-center justify-center", children: "gr" })] }), showValidation && ((0, jsx_runtime_1.jsx)("small", { className: "w-5/6 text-red-600", children: t('calibrationWeightRequired') })), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('save'), onClick: handleSave })] }));
};
exports.CalibrationModal = CalibrationModal;
